
// Custom regel för Vee-validate: 'sso-dashboard-namn-unikt'. Validerar att namnet är unikt *utan* att anropa remote/server:

import { Validator } from 'vee-validate';



// https://baianat.github.io/vee-validate/guide/custom-rules.html#using-the-custom-rule:

const ruleValidator = {

	getMessage(field, [selfPageId], data)
	{
		// will be added to default locale messages.
		// Returns a message.
		return 'Namnet används redan. Välj ett annat.';
	},

	validate(value, [selfPageId])
	{
		// Returns a Boolean or a Promise that resolves to a boolean.
		// value = fältets aktuella innehåll.

		// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
		let item = window.ssoOversikt.dashboardPages
			.filter((item) => {

				return (!selfPageId || item.PageId !== selfPageId)
					&& item.Name === value;

			})[0] || null;

		return (item ? false : true);
	}
};


let redanKord = false;


export default {

	runOnce()
	{
		if (!redanKord)
		{
			redanKord = true;
			Validator.extend('sso-dashboard-namn-unikt', ruleValidator);
		}
	}
}

